import React, { useRef } from "react";
import { useGetProjectsQuery } from "../../features/projects/projectsApi";
import { useAddTaskMutation } from "../../features/tasks/tasksApi";
import { useGetTeamQuery } from "../../features/team/teamApi";

export default function Form() {
  const { data: team } = useGetTeamQuery();
  const { data: projects } = useGetProjectsQuery();
  const [addTask, { isSuccess }] = useAddTaskMutation();
  const nameRef = useRef();
  const teamRef = useRef();
  const projectNameRef = useRef();
  const deadlineRef = useRef();

  const resetForm = () => {
    nameRef.current.value = "";
    teamRef.current.value = "";
    projectNameRef.current.value = "";
    deadlineRef.current.value = "";
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const teamMember = team?.find((t) => t.name === teamRef.current.value);
    const project = projects?.find(
      (p) => p.projectName === projectNameRef.current.value
    );
    const data = {
      taskName: nameRef.current.value,
      teamMember,
      project,
      deadline: deadlineRef.current.value,
      status: "inProgress",
    };
    addTask(data);
    resetForm();
  };

  return (
    <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
      <form className="space-y-6" onSubmit={handleSubmit}>
        <div className="fieldContainer">
          <label htmlFor="lws-taskName">Task Name</label>
          <input
            ref={nameRef}
            type="text"
            name="taskName"
            id="lws-taskName"
            required
            placeholder="Implement RTK Query"
          />
        </div>

        <div className="fieldContainer">
          <label>Assign To</label>
          <select
            ref={teamRef}
            name="teamMember"
            defaultValue=""
            id="lws-teamMember"
            required
          >
            <option value="" hidden>
              Select Team
            </option>
            {team?.map((t) => {
              return (
                <option value={t.name} key={t.id}>
                  {t.name}
                </option>
              );
            })}
          </select>
        </div>
        <div className="fieldContainer">
          <label htmlFor="lws-projectName">Project Name</label>
          <select
            ref={projectNameRef}
            id="lws-projectName"
            defaultValue=""
            name="projectName"
            required
          >
            <option value="" hidden>
              Select Project
            </option>
            {projects?.map((p) => (
              <option value={p.projectName} key={p.id}>
                {p.projectName}
              </option>
            ))}
          </select>
        </div>

        <div className="fieldContainer">
          <label htmlFor="lws-deadline">Deadline</label>
          <input
            ref={deadlineRef}
            type="date"
            name="deadline"
            id="lws-deadline"
            required
          />
        </div>

        <div className="text-right">
          <button type="submit" className="lws-submit">
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
